<template>
    <div class="page-article">
        <!--content-->
        <SupportList />
        <div class="container" v-for="item in gameInfo">
            <div class="single">
                <a href="#">
                  <el-image class="img-responsive" :src="'static/images/game/'+item.path+'/top.jpg'" alt=" ">
                    <div slot="placeholder" class="img-placeholder">
                      图片加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
                <div class=" single-grid">
                    <h4>{{item.title}}（{{item.enTitle}}）<span v-if="item.version">v {{item.version}}</span></h4>
                    <h4 class="grid2"><span class="label first">类型：</span>
                        <span v-for="(t,i) in item.type" :class="'label label-'+gameType[i]">{{t}}</span>
                    </h4>
                    <div class="cal">
                        <ul>
                            <li title="发布日期"><span><i class="glyphicon glyphicon-calendar"> </i>{{item.date}}</span></li>
                            <li title="最后更新日期" v-if="item.update"><span><i class="glyphicon glyphicon-refresh"> </i>{{item.update}}</span></li>
                        </ul>

                    </div>
                    <!--<div class="votes" >
                        <script type="text/javascript" charset="gb2312" src="http://likexia.com/vote/vote.asp?sid=9"></script>
                    </div>-->
                    <div class="tit">介绍</div>
                    <p>欢迎关注咱微信公众号：<b><font color="red">Git游戏</font></b>，可以及时获取最新游戏发布动态哦~​</p>
                    <br>
                    <div v-if="item.QQ">
                        <p>欢迎加入游戏交流QQ群：<font color="red">{{item.QQ}}</font>
                        </p>
                    </div>
                    <div v-for="(content,index) in item.content" v-if="content.length>0">
                        <p>{{content}}</p>
                    </div>
                    <div v-for="(content,index) in item.content" v-if="content.length<1">
                        <p>这是一款放置型经营游戏。游戏虽然没什么精美的图片和动听的音乐，但还是有相当的经营乐趣。</p>
                    </div>
                    <br>
                    <p>玩此类型游戏时，请大家记得定期保存、导出存档，备份到网盘、邮箱里面去，以免存档丢失，失去继续玩的动力。。</p>
                    <p>由于游戏还在不断更新新内容，如果你遇到不懂的地方，欢迎点下面的链接加入QQ群询问。 </p>
                    <p>建议使用Chrome（谷歌）或者Firefox（火狐）浏览器进行游戏。</p>
                    <br>
                    <p>适度游戏益脑，沉迷游戏伤身</p>
                    <p>合理安排时间，享受健康生活。</p>
                    <div class="tit">游戏地址</div>
                    <div class="btn-group">
                        <a v-if="item.zhUrl" :href="item.zhUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank">中文版</a>
                        <a v-if="item.enUrl" :href="item.enUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank">英文版</a>
                        <a v-if="item.kUrl" :href="item.kUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank">K站英文版</a>
                        <a v-if="item.steamUrl" :href="item.steamUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank">Steam版</a>
                        <a v-if="item.customUrl" :href="item.customUrl" :title="item.customUrlTit" class="cd-read-more  hvr-wobble-top" target="_blank">{{item.customUrlTit}}</a>
                        <a v-if="item.customUrl2" :href="item.customUrl2" :title="item.customUrlTit2" class="cd-read-more  hvr-wobble-top" target="_blank">{{item.customUrlTit2}}</a>
                        <a v-if="item.customUrl3" :href="item.customUrl3" :title="item.customUrlTit3" class="cd-read-more  hvr-wobble-top" target="_blank">{{item.customUrlTit3}}</a>
                        <a v-if="item.customUrl4" :href="item.customUrl4" :title="item.customUrlTit4" class="cd-read-more  hvr-wobble-top" target="_blank">{{item.customUrlTit4}}</a>
                        <a v-if="item.customUrl5" :href="item.customUrl5" :title="item.customUrlTit5" class="cd-read-more  hvr-wobble-top" target="_blank">{{item.customUrlTit5}}</a>
                        <a v-if="item.weiyunUrl" :href="item.weiyunUrl" title="微云网盘下载地址" class="cd-read-more  hvr-wobble-top" target="_blank">微云网盘下载</a>
                        <a v-if="item.baiduUrl" :href="item.baiduUrl" title="百度云盘下载地址" class="cd-read-more  hvr-wobble-top" target="_blank">百度网盘下载</a>
                        <a v-if="item.otherUrl" :href="item.otherUrl" title="其它下载地址" class="cd-read-more  hvr-wobble-top" target="_blank">其它下载地址</a>
                        <a v-if="item.wikiUrl" :href="item.wikiUrl" title="Wiki地址" class="cd-read-more  hvr-wobble-top" target="_blank">Wiki地址</a>
                        <a v-if="item.wikiUrl2" :href="item.wikiUrl2" title="Wiki地址2" class="cd-read-more  hvr-wobble-top" target="_blank">Wiki地址2</a>
                        <a v-if="item.hhUrl" :href="item.hhUrl" title="汉化导入方式" class="cd-read-more  hvr-wobble-top" target="_blank">汉化导入方式</a>
                        <a v-if="item.jbUrl" :href="item.jbUrl" title="自动脚本导入方式" class="cd-read-more  hvr-wobble-top" target="_blank">自动脚本导入方式</a>
                    </div>
                    <div class="tit">其它</div>
                    <div class="btn-group">
                        <a href="http://bbs.gityx.com" title="查看游戏攻略" class="cd-read-more  hvr-wobble-top btn-success" target="_blank">游戏攻略</a>
                        <!--						<a href="#" title="查看英文版游戏文档" class="cd-read-more  hvr-wobble-top btn-success" target="_blank">英文文档</a>-->
                        <a href="//qm.qq.com/cgi-bin/qm/qr?k=AnZJbnsU8BsmQGGEWs4rXd-JuSJI-j9c&jump_from=webapi" title="点击加入 - Git游戏放置交流群:793344327" class="cd-read-more  hvr-wobble-top btn-info" target="_blank">QQ交流群</a>
                        <a href="javascript:void(0)" title="您的支持，是我最大的动力！" class="cd-read-more  hvr-wobble-top btn-info btn-dashang" @click="open()">赞助支持</a>

                    </div>
                </div>

            </div>
        </div>

        <!--//content-->
        <!--images-->
        <div class="container" v-for="item in gameInfo">
            <div class="games">
                <div class="tit">游戏图鉴</div>
                <section>
                    <ul id="da-thumbs" class="da-thumbs tuijian">
                        <li>
                            <a :href="'static/images/game/'+item.path+'/face.jpg'" rel="标题" class="b-link-stripe b-animate-go thickbox" target="_blank">
                                <img class="img" :src="'static/images/game/'+item.path+'/face.jpg'" :alt="item.title" />
                                <img src="static/images/game/null.png" :alt="item.title" />
                                <div>
                                    <h5>封面</h5>
                                    <span>点击查看大图</span>
                                </div>
                            </a>
                        </li>
                        <li v-for="(pic,i) in item.pic">
                            <a :href="'static/images/game/'+item.path+'/jietu-'+pic+'.png'" :rel="item.title" class="b-link-stripe b-animate-go  thickbox" target="_blank">
                              <el-image class="img" :src="'static/images/game/'+item.path+'/jietu-'+pic+'.png'" :alt="item.title">
                                <div slot="placeholder" class="img-placeholder small">
                                  图片加载中<span class="dot">...</span>
                                </div>
                              </el-image>
                                <img src="static/images/game/null.png" :alt="item.title" />
                                <div>
                                    <h5>游戏截图</h5>
                                    <span>{{item.title}}截图{{pic}}</span>
                                </div>
                            </a>
                        </li>
                        <div class="clearfix"></div>
                    </ul>
                </section>

            </div>
        </div>
        <!--//images-->
        <!--分享 开始-->
        <!--<div class="contact">-->
        <!--<div class="container">-->
        <!--<div class="bdsharebuttonbox"><a href="" style="background:none;text-decoration:none;color:#000;font-size:14px;">分享到：</a><a href="#" class="bds_sqq" data-cmd="sqq" title="分享到QQ好友">QQ好友</a><a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信">微信</a><a href="#" class="bds_qzone" data-cmd="qzone" title="分享到QQ空间">QQ空间</a><a href="#" class="bds_tsina" data-cmd="tsina" title="分享到新浪微博">新浪微博</a><a href="#" class="bds_more" data-cmd="more">更多：</a></div>-->
        <!--<script>window._bd_share_config={"common":{"bdSnsKey":{},"bdText":"","bdMini":"2","bdMiniList":false,"bdPic":"","bdStyle":"0","bdSize":"16"},"share":{"bdSize":16}};with(document)0[(getElementsByTagName('head')[0]||body).appendChild(createElement('script')).src='http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion='+~(-new Date()/36e5)];</script>-->
        <!--</div></div>-->
        <!--分享 结束-->
        <!--评论 开始-->
        <!--<div class="contact">-->
        <!--<div class="container">-->
        <!--&lt;!&ndash; 来必力City版安装代码 &ndash;&gt;-->
        <!--<div id="lv-container" data-id="city" data-uid="MTAyMC8zMzc2Mi8xMDMxNg==">-->
        <!--<script type="text/javascript">-->
        <!--(function(d, s) {-->
        <!--var j, e = d.getElementsByTagName(s)[0];-->

        <!--if (typeof LivereTower === 'function') { return; }-->

        <!--j = d.createElement(s);-->
        <!--j.src = 'https://cdn-city.livere.com/js/embed.dist.js';-->
        <!--j.async = true;-->

        <!--e.parentNode.insertBefore(j, e);-->
        <!--})(document, 'script');-->
        <!--</script>-->
        <!--<noscript> 为正常使用来必力评论功能请激活JavaScript</noscript>-->
        <!--</div>-->
        <!--&lt;!&ndash; City版安装代码已完成 &ndash;&gt;-->
        <!--</div></div>-->
        <!--评论 结束-->
    </div>
</template>

<script>
import SupportList from '@/components/Support.vue'
export default {
  name: 'Article',
  components: {
    SupportList
  },
  data() {
    return {
      gameInfo: [],
      gameType: ['primary', 'success', 'default', 'info', 'warning', 'danger', 'add1', 'add2', 'add3', 'add4', 'add5', 'add6'],
      id: this.$route.params.id,
      num: 0,
      vote: ''
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(res => {
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].path === this.id) {
            this.gameInfo.push(res.data[i])
            document.title = res.data[i].title + ' - Git游戏 - gityx.com'
            // console.log(this.gameInfo);
            this.num = 1
          }
        }
        if (this.num < 1) {
          //                            console.log(this.num)
          this.$router.push({
            path: '/'
          })
        }
      },
      res => {
        console.log('error')
      }
      )
    },
    open() {
      $('.hide_box').fadeIn()
      $('.shang_box').fadeIn()
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Article.vue